import api from '@/api/profile'

export default {
    namespaced: true,
    state: {
        currentStep: 'info',
        steps: ['info', 'address', 'orders', 'favorites'],
        profile: null,
        errors: [],
    },
    getters: {
        currentStep(state) {
            return state.currentStep;
        },
        profile(state) {
            return state.profile;
        },
        errors(state) {
            return state.errors;
        }
    },
    mutations: {
        setStep(state, stepName) {
            let stepIdx = state.steps.indexOf(stepName);

            if (stepIdx === -1) {
                throw 'Invalid step name';
            }

            state.currentStep = stepName;
        },
        setProfile(state, profileData) {
            state.profile = profileData;
        },
        setErrors(state, errors) {
            state.errors = errors;
        }
    },
    actions: {
        setStep({commit}, step) {
            commit('setStep', step);
        },
        async loadProfile({commit}) {
            await api.loadUserProfile({}, (responseData) => {
                commit('setProfile', responseData.data);
                },
                err => console.log(err)
            )
        },
        async saveUserProfile({commit}, profile) {
            await api.saveUserProfile(profile, () => {
                    commit();
                },
                err => console.log(err)
            );
        },
    }
}